import axios from "@/plugins/axios";

export default {
  getImageList(searchQuery) {
    return axios.get("/images/types/search", {
      params: { ...searchQuery },
    });
  },
  getImageCount(searchQuery) {
    return axios.get("/images/types/count", {
      params: { ...searchQuery },
    });
  },
  getOneImage(image_id) {
    return axios.get(`/images/${image_id}`);
  },
  addImage(data) {
    return axios.post("/images", data);
  },
  updateImage(image_id, data, cache) {
    return axios.post(`/images/${image_id}`, { data, cache });
  },
  deleteImage(image_id) {
    return axios.delete(`/images/${image_id}`);
  },
  checkImageInQuote(image_id) {
    return axios.get(`/quotes/images/${image_id}`);
  },
};
